import axios from "axios";
import { AUTH, ENVIRONMENT_MODE, ENVIRONMENT_MODES, TOKEN_KEY } from "../constants/SYSTEM";
import { get, set } from "../helpers/storage";

const onRequest = (config) => {
  if(config.baseURL?.includes("widget")) {
    config.headers["Authorization"] = AUTH;
    return config;
  }
  const token = get(TOKEN_KEY);
  if (token) {
    const { jwtToken } = token;
    config.headers["Authorization"] = `Bearer ${jwtToken}`;
    return config;
  }
  return config;
};

const onRequestError = (error) => {
  return Promise.reject(error);
};

const onResponse = (response) => {
  return response;
};

const onResponseError = async (error) => {
  if (error.response) {
    // Access Token was expired
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
      //error.response.data.message === "jwt expired"
      const token = get(TOKEN_KEY);

      try {
        const { jwtToken: storedToken, loginDate } = token;

        const API =
          ENVIRONMENT_MODE === ENVIRONMENT_MODES.PRODUCTION
            ? "https://adminapiv2.heycarter.co.za"
            : ENVIRONMENT_MODE === ENVIRONMENT_MODES.DEVELOPMENT
              ? "https://devadminapiv2.heycarter.co.za"
              : "https://localhost:44383";
        const res = await axios.post(`${API}/Refresh?token=${storedToken}`);

        const { jwtToken } = res.data;

        const newToken = {
          jwtToken,
          loginDate,
        };

        set(TOKEN_KEY, newToken);

        originalRequest.headers["Authorization"] = `Bearer ${jwtToken}`;
        return axios(originalRequest);
      } catch (_error) {
        return Promise.reject(_error);
      }
    }
  }
  return Promise.reject(error);
};

export const setupInterceptorsTo = (axiosInstance) => {
  axiosInstance.interceptors.request.use(onRequest, onRequestError);
  axiosInstance.interceptors.response.use(onResponse, onResponseError);
  return axiosInstance;
};
